import {AbstractControl, FormGroup} from '@angular/forms';
import {Component, Inject, OnInit} from '@angular/core';
import {Config} from '../../../models/config';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-form-link',
  templateUrl: './form-link.component.html',
  styleUrls: ['./form-link.component.scss']
})
export class FormLinkComponent implements OnInit {

  config: Config;
  group: FormGroup;
  isEdit: boolean;
  isAdd: boolean;
  isExchange: boolean;
  orderType: number;
  controlName = null;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {
  }

  ngOnInit(): void {}

  get getControlName(): AbstractControl {
    return this.group.get(this.config.controlName[0]);
  }
}
